import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import SortListItem from './SortListItem';

const listItemTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem();
    const { preventDropOn } = item;
    if (!preventDropOn) {
      return true;
    }
    return preventDropOn !== props.id;
  },
  drop(props, monitor, component) {
    const { id, drop } = props;
    const sourceObj = monitor.getItem();
    if (id !== sourceObj.listId) {
      props.addItem(sourceObj.source);
    }
    findDOMNode(component)
      .querySelectorAll('.over')
      .forEach(over => {
        over.classList.remove('over');
      });
    if (drop) {
      drop();
    }
    return {
      listId: id,
    };
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

class SortList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      list,
      className,
      children,
      connectDropTarget,
      removeItem,
      moveItem,
      id,
      canDrop,
      isOver,
      preventDrag,
      supressEmptyMessage,
    } = this.props;

    const isActive = canDrop && isOver;

    return connectDropTarget(
      <ul
        className={`${className} ${isActive ? 'dropping ' : ' '}sort-list`}
        id={id}
        ref={ghost_list => {
          this.ghost_list = ghost_list;
        }}
      >
        {children}
        {!!list.length &&
          list.map((item, i) => (
            <SortListItem
              className={item.className}
              listClassName={item.listClassName}
              sortIndex={i}
              originalIndex={item.originalIndex}
              isDragging={false}
              listId={id}
              id={list[i].id}
              hidden={item.hidden}
              preventDropOn={list[i].preventDropOn}
              moveListItem={moveItem.bind(this)}
              removeItem={removeItem.bind(this)}
              item={list[i].item}
              source={list[i].sourceListItem}
              preventDrag={preventDrag}
            >
              {list[i].item}
            </SortListItem>
          ))}
        {!list.length && !supressEmptyMessage && (
          <li className="empty">There are no items in this list.</li>
        )}
      </ul>,
    );
  }
}

DropTarget.propTypes = {
  removeItem: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  moveItem: PropTypes.func.isRequired,
};

export default DropTarget('SortListItem', listItemTarget, collect)(SortList);
